module.exports = __webpack_public_path__ + "static/media/teeth-open.d7ed3557.svg";